var BridgeEvents;
(function(BridgeEvents) {
    BridgeEvents["MESSAGE"] = 'message';
    BridgeEvents["UNSUPPORTED_MESSAGE"] = 'unsupported_message';
})(BridgeEvents || (BridgeEvents = {}));

export { BridgeEvents };
